package com.gastoncantera.intercom.ui

import androidx.compose.runtime.Composable
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlin.js.Promise

actual suspend fun ensureNotificationPermission(): Boolean {
    val notification = window.asDynamic().Notification ?: return false // navegador sin soporte
    return when (notification.permission as? String) {
        "granted" -> true
        "denied" -> false
        else -> {
            // requestPermission devuelve Promise<String> en navegadores modernos.
            val result = (notification.requestPermission() as Promise<String>).await()
            result == "granted"
        }
    }
}

// El navegador no permite re-pedir el permiso programáticamente: se cambia desde el candado del
// sitio. Por eso no ofrecemos botón (el cartel muestra solo el mensaje).
@Composable
actual fun rememberNotificationPermissionAction(onResolved: () -> Unit): (() -> Unit)? = null

// El full-screen intent es un concepto de Android; en web no aplica.
@Composable
actual fun rememberFullScreenCallPermissionAction(): (() -> Unit)? = null
